import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MODAL_STATUS } from '../../interfaces.js';
import i18nInstance from '../../localeImport.js';
import Button from '../Button/Button.js';
import Loader from '../Loader.js';
import WalletConnect from '../WalletConnect.js';
import ExternalWalletHeader from './ExternalWalletHeader.js';
import ExternalWalletInstall from './ExternalWalletInstall.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function ExternalWalletConnect(props) {
  const {
    connectButton,
    walletConnectUri,
    goBack,
    closeModal
  } = props;
  const [isWalletDownloadShown, setIsWalletDownloadShown] = useState(false);
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  const showWalletDownload = () => {
    setIsWalletDownloadShown(true);
  };
  return /*#__PURE__*/jsx("div", {
    children: isWalletDownloadShown ? /*#__PURE__*/jsx("div", {
      children: /*#__PURE__*/jsx(ExternalWalletInstall, {
        connectButton: connectButton,
        goBack: () => setIsWalletDownloadShown(false),
        closeModal: closeModal
      })
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(ExternalWalletHeader, {
        title: connectButton.displayName,
        goBack: goBack,
        closeModal: closeModal
      }), !walletConnectUri ? /*#__PURE__*/jsx(Loader, {
        modalStatus: MODAL_STATUS.CONNECTING,
        canEmit: false
      }) : /*#__PURE__*/jsx(WalletConnect, {
        walletConnectUri: walletConnectUri,
        logoImage: `https://images.web3auth.io/login-${connectButton.name}.${connectButton.imgExtension}`,
        primaryColor: connectButton.walletRegistryItem.primaryColor
      }), connectButton.hasInstallLinks && /*#__PURE__*/jsxs("div", {
        className: "w3a--flex w3a--flex-row w3a--items-center w3a--justify-between w3a--gap-2 w3a--bg-app-gray-50 dark:w3a--bg-app-gray-700 w3a--text-app-gray-900 dark:w3a--text-app-white w3a--px-3 w3a--py-2 w3a--rounded-xl",
        children: [/*#__PURE__*/jsxs("span", {
          className: "w3a--text-sm w3a--truncate w3a--flex-grow-0",
          children: [t("modal.external.dont-have"), " ", /*#__PURE__*/jsx("span", {
            children: connectButton.displayName
          }), "?"]
        }), /*#__PURE__*/jsx(Button, {
          type: "button",
          variant: "secondary",
          size: "xs",
          className: "w3a--flex-grow-1 w3a--flex-shrink-0",
          onClick: showWalletDownload,
          children: t("modal.external.get-wallet")
        })]
      })]
    })
  });
}

export { ExternalWalletConnect as default };
